import * as ActionTypes from './ActionTypes';
import { fetchWrapper } from '../../_helpers';

const groupVisitsByEmployee = (visits = []) => {
    return visits.reduce((acc, visit) => {
        const empId = visit?.employee?._id;
        if (!empId) return acc;

        if (!acc[empId]) {
            acc[empId] = {
                employee: visit.employee,
                visits: [],
                forms: [],
            };
        }

        acc[empId].visits.push(visit);
        if (visit?.forms) {
            acc[empId].forms.push(...visit.forms);
        }
        return acc;
    }, {});
};

export const getTeamSummary =
    ({ providerId, team, startDate, endDate }) =>
    async (dispatch) => {
        try {
            const params = new URLSearchParams();
            if (!team) {
                return;
            }

            if (providerId) params.append('provider', providerId);
            if (startDate) params.append('startDate', startDate);
            if (endDate) params.append('endDate', endDate);
            const url = `/analytics/team/${team}/summary?${params.toString()}`;
            const response = await fetchWrapper.get(url);
            const payload = {
                totalEmployees: response?.staffCount || 0,
                totalVisits: response?.visitCount || 0,
                totalFormsSubmitted: response?.userFormDataCount || 0,
                totalSchedules: response?.taskCount || 0,
                loading: false,
            };

            dispatch(setTeamDashboardSummary(payload));
            return true;
        } catch (error) {
            if (error.name !== 'AbortError') {
            }
            return false;
        }
    };

export const getTeamVisits =
    ({ employee, client, provider, page = 1, endDate, startDate, sortBy, team }) =>
    async (dispatch) => {
        try {
            dispatch(setTeamDashboardVisit({ loading: true }));
            const params = new URLSearchParams({
                page,
                limit: 100,
            });
            const mileageParams = new URLSearchParams({});

            if (team) {
                params.append('team', team);
                mileageParams.append('team', team);
            }
            if (employee) {
                params.append('employee', employee);
                mileageParams.append('employee', employee);
            }
            if (client) {
                params.append('client', client);
                mileageParams.append('client', client);
            }
            if (provider) {
                params.append('provider', provider);
                mileageParams.append('provider', provider);
            }
            if (sortBy) params.append('sortBy', sortBy);
            if (endDate) {
                params.append('serviceEndAt', endDate);
                mileageParams.append('endDate', endDate);
            }
            if (startDate) {
                params.append('serviceCreatedAt', startDate);
                mileageParams.append('startDate', startDate);
            }

            const visitUrl = `evv/visit?${params.toString()}`;
            const mileageUrl = `/analytics/team/${team}/mileage-summary?${mileageParams.toString()}`;

            const [response, mileageResponse] = await Promise.all([
                fetchWrapper.get(visitUrl),
                fetchWrapper.get(mileageUrl),
            ]);
            const payload = {
                ...response,
                groupedVisitsByEmployee: groupVisitsByEmployee(response?.results || []),
                groupedMileageByEmployee: mileageResponse?.groupedMileageByEmployee || {},
                loading: false,
            };
            dispatch(setTeamDashboardVisit(payload));
            return true;
        } catch (error) {
            if (error.name !== 'AbortError') {
            }
            return false;
        }
    };

export const setTeamDashboardSummary = (data) => ({
    type: ActionTypes.SET_TEAM_DASHBOARD_SUMMARY,
    payload: data,
});

export const setTeamDashboardVisit = (data) => ({
    type: ActionTypes.SET_TEAM_DASHBOARD_VISITS,
    payload: data,
});

export const clearDashboard = () => ({
    type: ActionTypes.CLEAR_DASHBOARD,
});
